(function () {
  var root = document.querySelector('[data-kbs]');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var ls = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  var form = $('#kbs-loc-form');
  function submitLoc(country, lang) {
    if (!form) return;
    if (country) $('[data-loc-country]').value = country;
    if (lang) $('[data-loc-lang]').value = lang;
    ls.set('kbs_welcome_done', '1');
    form.submit();
  }
  var welcome = $('[data-welcome]');
  function openWelcome() { if (welcome) welcome.hidden = false; }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-country]');
    if (t && !t.disabled) {
      var pick = $('[data-wlang].on', welcome);
      submitLoc(t.getAttribute('data-country'), pick && !welcome.hidden ? pick.getAttribute('data-wlang') : null);
      return;
    }
    t = e.target.closest('[data-lang]');
    if (t) { submitLoc(null, t.getAttribute('data-lang')); return; }
    t = e.target.closest('[data-wlang]');
    if (t) {
      $$('[data-wlang]').forEach(function (b) { b.classList.toggle('on', b === t); });
      return;
    }
    if (e.target.closest('[data-welcome-open]')) { openWelcome(); return; }
  });

  $$('[data-dd]').forEach(function (d) {
    var b = $('.kdd__b', d);
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      var was = d.classList.contains('o');
      $$('[data-dd]').forEach(function (x) { x.classList.remove('o'); });
      d.classList.toggle('o', !was);
      b.setAttribute('aria-expanded', String(!was));
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dd]')) $$('[data-dd]').forEach(function (x) { x.classList.remove('o'); });
  });

  if (welcome) {
    var force = /[?&]welcome=1/.test(location.search);
    if (force || !ls.get('kbs_welcome_done')) openWelcome();
    welcome.addEventListener('click', function (e) { if (e.target === welcome) { welcome.hidden = true; ls.set('kbs_welcome_done', '1'); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !welcome.hidden) { welcome.hidden = true; ls.set('kbs_welcome_done', '1'); } });
  }

  var nav = $('.kbs-nav');
  var megas = { cat: $('[data-mega=cat]'), brands: $('[data-mega=brands]') };
  var timer;
  function closeAll() {
    Object.keys(megas).forEach(function (k) { if (megas[k]) megas[k].hidden = true; });
    $$('[data-open]').forEach(function (a) { a.classList.remove('o'); });
  }
  function setRail(h) {
    $$('.kcat__rail [data-rail]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-rail') === h); });
    $$('.kcat__p').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== h; });
  }
  function open(kind, a) {
    clearTimeout(timer);
    closeAll();
    if (!megas[kind]) return;
    megas[kind].hidden = false;
    a.classList.add('o');
    if (kind === 'cat') setRail(a.getAttribute('data-rail'));
  }
  if (nav) {
    $$('[data-open]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { timer = setTimeout(function () { open(a.getAttribute('data-open'), a); }, 80); });
      a.addEventListener('focus', function () { open(a.getAttribute('data-open'), a); });
    });
    nav.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(closeAll, 180); });
    nav.addEventListener('mouseenter', function () { clearTimeout(timer); });
    $$('.kcat__rail button').forEach(function (b) {
      b.addEventListener('mouseenter', function () { setRail(b.getAttribute('data-rail')); });
      b.addEventListener('click', function () { setRail(b.getAttribute('data-rail')); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  $$('[data-bfilter]').forEach(function (box) {
    var letter = '', q = '';
    var none = $('.kbr__none', box);
    function apply() {
      var active = !!(letter || q);
      box.classList.toggle('f-on', active);
      var shown = 0;
      $$('[data-sec=more] .kb:not(.kb--all)', box).forEach(function (kb) {
        var ok = (!letter || kb.getAttribute('data-l') === letter) && (!q || kb.getAttribute('data-n').indexOf(q) > -1);
        kb.classList.toggle('nm', !ok);
        if (ok) shown++;
      });
      var all = $('.kb--all', box);
      if (all) all.style.display = active ? 'none' : '';
      if (none) none.hidden = !(active && shown === 0);
      $$('.az', box).forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-az') === letter); });
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.az');
      if (!b || b.disabled) return;
      letter = b.getAttribute('data-az');
      apply();
    });
    var inp = $('[data-bsearch]', box);
    if (inp) inp.addEventListener('input', function () { q = inp.value.trim().toLowerCase(); apply(); });
  });

  var FK = 'kbs_fav_brands', PK = 'kbs_fav_products';
  function rd(k) { try { var v = JSON.parse(ls.get(k) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function paintFavs() {
    var fb = rd(FK), fp = rd(PK);
    Array.prototype.forEach.call(document.querySelectorAll('[data-fav]'), function (b) {
      var on = fb.indexOf(b.getAttribute('data-fav')) > -1;
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', String(on));
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-kw]'), function (b) {
      var on = fp.indexOf(b.getAttribute('data-kw')) > -1;
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', String(on));
    });
    refreshWish();
  }
  window.kbsWishPaint = paintFavs;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav],[data-kw]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var isP = b.hasAttribute('data-kw');
    var k = isP ? PK : FK, h = b.getAttribute(isP ? 'data-kw' : 'data-fav');
    var a = rd(k), i = a.indexOf(h);
    if (i > -1) a.splice(i, 1); else a.push(h);
    ls.set(k, JSON.stringify(a));
    paintFavs();
    window.dispatchEvent(new CustomEvent('kbs:wish', { detail: { type: isP ? 'p' : 'b', handle: h, on: i < 0 } }));
  }, true);
  var mo, mt;
  if (window.MutationObserver) {
    mo = new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(paintFavs, 120); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  var drawer = $('[data-drawer]');
  function drawerSet(on) {
    if (!drawer) return;
    drawer.hidden = !on;
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { drawerSet(true); return; }
    if (e.target.closest('[data-drawer-close]')) { drawerSet(false); return; }
    var tab = e.target.closest('[data-tab]');
    if (tab) {
      $$('[data-tab]').forEach(function (b) { b.classList.toggle('on', b === tab); });
      $$('[data-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== tab.getAttribute('data-tab'); });
      return;
    }
    var h = e.target.closest('.kacc__h');
    if (h && h.tagName === 'BUTTON') {
      var body = h.nextElementSibling, on = h.getAttribute('aria-expanded') !== 'true';
      h.setAttribute('aria-expanded', String(on));
      body.hidden = !on;
      return;
    }
    if (e.target.closest('[data-msearch]')) {
      var s = $('.kbs-ms'); s.hidden = !s.hidden;
      if (!s.hidden) $('input', s).focus();
    }
  });

  function setCount(sel, n) {
    $$(sel, document).forEach(function (a) {
      var em = $('em', a); if (!em) return;
      em.textContent = n; em.hidden = !(n > 0);
    });
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount('[data-kbs-cart]', c.item_count); })
      .catch(function () {});
  }
  var _f = window.fetch;
  window.fetch = function () {
    var u = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _f.apply(this, arguments);
    if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refreshCart, 300); }).catch(function () {});
    return p;
  };
  window.addEventListener('pageshow', refreshCart);
  function refreshWish() {
    setCount('[data-kbs-wish]', rd(PK).length + rd(FK).length);
  }
  paintFavs();
  window.addEventListener('storage', paintFavs);
  window.addEventListener('pageshow', paintFavs);
})();

